module.exports = __webpack_public_path__ + "images/emoji/flags.ab4d442b7f0e2d392af1.png";